import { MenuIcon } from '@braskai/icons';

import { useInterfaceLanguage } from '@/shared/i18n';

import { SIconButton } from './styled';

export type TBurgerButtonProps = {
  'data-testid'?: string;
  onClick: () => void;
};

export const BurgerButton = ({
  'data-testid': dataTestId = 'burger-button-open-sidebar',
  onClick,
}: TBurgerButtonProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <SIconButton aria-label={t('common.openSidebar')} data-testid={dataTestId} onClick={onClick}>
      <MenuIcon height={20} width={20} />
    </SIconButton>
  );
};
